import axios from 'axios';
import { 
  GET_WALLET_TRANSACTION_URL,
  DECLINE_URL,
  getWalledByUserId,
  getWalledByTransactionId,
} from "../constants/index";


import { ISendRecieveParams } from '../interfaces/sendRecive';

export function getSendRecieveList(data: ISendRecieveParams) {
  return axios.get(GET_WALLET_TRANSACTION_URL, {params: {
    userId: data.userId, 
    // type: data.type,
    from: data.from,
    to: data.to,
    page: data.page,
    size: data.size,
    // operation: data.operation,
    // sort: 'opened,desc'
  }});
}

export function getTransactionByTransactionId(transactionId: string) {
  return axios.get(getWalledByTransactionId(transactionId))
}

export function getTransactionByUserId(userId: string) {
  return axios.get(getWalledByUserId(userId))
}

export function declineTransaction(transferId: string) {
  return axios.post(`${DECLINE_URL}/${transferId}/decline`)
}

export function approveTransaction(transferId: string) {
  return axios.post(`${DECLINE_URL}/${transferId}/approve`)
}


